import { request } from "hooks/useOkoApi/useOkoApi";

// Curriculum + course (Grade) + unit (with embedded lessons) hierarchy. Shared
// shape with hooks/useCurriculum/useCurriculum.js, but fetched here as plain
// promises (no react-query) to keep this hook's cascade+reset logic simple to
// unit-test with a mocked `request`.
export const fetchCurricula = () => request("curriculum", { method: "GET" });

export const fetchCourses = (curriculumId) =>
  request(`curriculum/${curriculumId}/courses`, { method: "GET" });

export const fetchUnits = (courseId) =>
  request(`curriculum/courses/${courseId}/units`, { method: "GET" });

// The IM items for a lesson (student/teacher HTML pairs). Section-type
// filtering happens client-side over this response — no separate endpoint.
export const fetchImItems = ({ lessonId }) =>
  request(`admin/curriculum/im-items?lesson_id=${lessonId}`, { method: "GET" });
